// Potential to delete this file as it doesn't seem to be doing anything
// Most likely broke during Vue 2 to Vue 3 migration
// Functionality covered by /server/middleware/trailingSlash.js
// If removing, also remove reference from router config in nuxt.config.js
export default function({ route, redirect }) {
  // Check if it's not the homepage and ends with a trailing slash
  if (route.fullPath !== '/' && route.fullPath.endsWith('/')) {
    const redirectUrl = route.fullPath.slice(0, -1);
    redirect(301, redirectUrl);
  }
}
